import { ValidationBase } from "@inter-ikea-core/core-toolbox";
import { calculateLeftUprightConnections, getInsertConnectionValidity, } from "../functions/HoleOccupation";
import { getSectionUprightsByUpright } from "../utils/sectionsHelpers";
import { getInsertPossibleAlignments } from "../functions/Alignment";
import { generateValidationFail, entityIsAdjustable, isInsertBeingMoved, } from "../utils/helpers";
import { CHILD_MISSING_PARENT } from "@inter-ikea-storagetwo/range/dist/constants/errors";
const FAIL_MSG = "Shelf not placeable";
export default class ShelfPlacementValidation extends ValidationBase {
    constructor() {
        super(...arguments);
        this.id = "ShelfPlacementValidation";
    }
    validateCurrentState(_entity) {
        return null;
    }
    validateSnap(snapActionCandidate) {
        const { guest, host } = snapActionCandidate;
        if (!isInsertBeingMoved(snapActionCandidate) ||
            entityIsAdjustable(snapActionCandidate.guest))
            return null;
        snapActionCandidate.performMove();
        if (!getInsertPossibleAlignments(snapActionCandidate.guest, snapActionCandidate.host).length)
            return generateValidationFail(snapActionCandidate.guest, FAIL_MSG);
        const { leftUpright, rightUpright } = getSectionUprightsByUpright(host);
        if (!leftUpright || !rightUpright) {
            throw new Error(CHILD_MISSING_PARENT);
        }
        const leftRes = calculateLeftUprightConnections(snapActionCandidate, rightUpright);
        const rightIsValid = getInsertConnectionValidity(snapActionCandidate, rightUpright);
        return rightIsValid && leftRes
            ? null
            : generateValidationFail(guest, FAIL_MSG);
    }
}
